
import React from "react";
import FAQItem from "./FAQItem";

const ProtocolsSection: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">Remote Viewing Protocols</h2>
      
      <FAQItem question="Do you follow official remote viewing protocols?">
        <p className="text-foreground mb-3">
          Yes, we adhere to the core principles established by the CIA's Project Stargate and the Stanford Research Institute. Our methodology incorporates:
        </p>
        <ul className="list-disc list-inside text-foreground space-y-1 ml-4">
          <li>Blind targeting (you only see a code, not the target)</li>
          <li>Structured data collection</li>
          <li>Objective feedback mechanisms</li>
          <li>Double-blind target selection (neither you nor the system operator knows the target beforehand)</li>
        </ul>
      </FAQItem>

      <FAQItem question="How rigorous are your protocols compared to CIA/Project Stargate standards?">
        <p className="text-foreground mb-3">
          Our system maintains the essential elements of military remote viewing protocols:
        </p>
        <ul className="list-disc list-inside text-foreground space-y-1 ml-4">
          <li>Random target selection with no human bias</li>
          <li>Proper target coding systems</li>
          <li>Separation between targeting and viewing phases</li>
          <li>Analytical feedback comparing impressions to actual targets</li>
          <li>Statistical tracking for skill development</li>
        </ul>
        <p className="text-foreground mt-3">
          While we adapt these protocols for digital use, we preserve their scientific rigor and effectiveness.
        </p>
      </FAQItem>
    </section>
  );
};

export default ProtocolsSection;
